module.exports = __webpack_public_path__ + "static/media/bjsp.0b4f6ff.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bjsp.mp4
// module id = 2Eqj
// module chunks = 1